<script setup lang="ts">
import { BookOpen } from '@lucide/vue'
import { computed } from 'vue'
import { me } from '../session'
import Logo from './Logo.vue'
import NavList from './NavList.vue'

const initials = computed(() =>
  (me.value?.tenant.name ?? '')
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase(),
)
const checkoutHost = computed(() => me.value?.tenant.checkout_host ?? '')
</script>

<template>
  <aside class="fixed inset-y-0 left-0 z-30 w-64 flex-col border-r border-border bg-background/80 backdrop-blur-xl">
    <div class="flex h-16 items-center px-5">
      <RouterLink to="/payments" aria-label="FlowFront console home"><Logo /></RouterLink>
    </div>
    <div class="mx-3 mb-4 flex items-center gap-3 rounded-xl border border-border bg-card px-3 py-2.5">
      <div class="flex size-8 items-center justify-center rounded-lg bg-gradient-to-br from-zinc-700 to-zinc-900 font-heading text-xs font-bold text-white">
        {{ initials }}
      </div>
      <div class="min-w-0">
        <p class="truncate text-[13px] font-medium">{{ me?.tenant.name ?? '—' }}</p>
        <p class="truncate text-xs text-muted-foreground">{{ checkoutHost }}</p>
      </div>
    </div>
    <div class="scrollbar-thin flex-1 overflow-y-auto px-3">
      <NavList layout-key="desktop" />
    </div>
    <div class="flex flex-col gap-0.5 border-t border-border p-3">
      <RouterLink to="/developers/docs" class="flex h-8 items-center gap-3 rounded-lg px-3 text-[13px] text-muted-foreground hover:bg-muted hover:text-foreground">
        <BookOpen class="size-4" /> API reference
      </RouterLink>
    </div>
  </aside>
</template>
